<template>
  <div>

    <li>
      <div>
        <template v-if="isClickable">
          <b-button variant="link" style="padding:0" @click="handleClick(node)">
            {{ node.name }}
          </b-button>
        </template>
        <template v-else>
          {{ node.name }}&nbsp;
        </template>
        <span
          v-if="isFolder"
          :class="{ 'clickable' : isFolder }"
          @click="toggle">
          &nbsp;[{{ open ? '-' : '+' }}]
        </span>
      </div>
      <ul v-show="open" v-if="isFolder">
        <node
          v-for="(node, index) in node.children"
          :selectable-type="selectableType"
          :handle-click="handleClick"
          :key="index"
          :node="node"
          class="node"/>
      </ul>
    </li>

  </div>
</template>

<script>
export default {
  name: 'node', // eslint-disable-line
  props: {
    node: {
      type: Object,
      required: true
    },
    selectableType: {
      type: String,
      required: true
    },
    handleClick: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      open: false,
      showPreviewModal: false,
      modalData: {},
      fetchingModalData: false
    }
  },
  computed: {
    isClickable () {
      return this.node.type === this.selectableType
    },
    isFolder () {
      return this.node.children && this.node.children.length
    }
  },
  methods: {
    toggle () {
      if (this.isFolder) {
        this.open = !this.open
      }
    },
    selected () {
      this.$emit('selected', this.node.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
ul {
  padding-left: $spacing-sm;
  list-style-type: dot;
}
</style>



// WEBPACK FOOTER //
// src/components/common/move-entity/node.vue